module.exports = __webpack_public_path__ + "static/turner-f55717dad79d6b25216328c6db73023b.png";